import { LuckyGiftPopupComponent } from './../layouts/lucky-gift-popup/lucky-gift-popup.component';
import { OutOfStockPopupComponent } from './../layouts/out-of-stock-popup/out-of-stock-popup.component';
import { QrScannerComponent } from './../layouts/qr-scanner/qr-scanner.component';
import { InvoiceConfirmComponent } from './../layouts/invoice-confirm/invoice-confirm.component';
import { Html5CameraComponent } from './../layouts/html5-camera/html5-camera.component';
import { BankerselectComponent } from './../layouts/bankerselect/bankerselect.component';
import { InvalidInvoicePopupComponent } from './../layouts/invalid-invoice-popup/invalid-invoice-popup.component';
import { MessagePopupComponent } from './../layouts/message-popup/message-popup.component';
import { CameraStandardComponent } from './../layouts/camera-standard/camera-standard.component';
import { HttpModule } from '@angular/http';
import { ZeroBeforePipe } from './../common/pipe/zero-before.pipe';
import { TitleCampaignPipe } from './../pipe-transform/title-campaign.pipe';
import { FooterComponent } from './../layouts/footer/footer.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'app/shared/layouts/header/header.component';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SafeHtmlPipe } from '../common/pipe/safe-html.pipe';
import { SafeUrlPipe } from './../common/pipe/safe-url.pipe';
import {WebcamModule} from 'ngx-webcam';
import { BillComponent } from '../layouts/bill/bill.component';
import { CheckboxModule } from 'primeng/checkbox';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import {ZXingScannerModule} from '@zxing/ngx-scanner'


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    TitleCampaignPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    ZeroBeforePipe,
    CameraStandardComponent,
    MessagePopupComponent,
    BillComponent,
    InvalidInvoicePopupComponent,
    BankerselectComponent,
    Html5CameraComponent,
    InvoiceConfirmComponent,
    QrScannerComponent,
    OutOfStockPopupComponent,
    LuckyGiftPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    WebcamModule,
    CheckboxModule,
    Ng2ImgMaxModule,
    ZXingScannerModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SafeHtmlPipe,
    SafeUrlPipe,
    ZeroBeforePipe,
    CameraStandardComponent,
    MessagePopupComponent,
    BillComponent,
    InvalidInvoicePopupComponent,
    BankerselectComponent,
    Html5CameraComponent,
    InvoiceConfirmComponent,
    QrScannerComponent,
    OutOfStockPopupComponent,
    LuckyGiftPopupComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents:[]
})
export class ShareModule { }
